module.exports = __webpack_public_path__ + "img/backpeople.60133004.jpg";